import { CHANGE_CONTRACTOR_ENROLLMENT_VALUE } from './actionTypes';

export const changeContractorEnrollmentValue = (key, value) => ({
  type: CHANGE_CONTRACTOR_ENROLLMENT_VALUE,
  key,
  value,
});
